import { faLayerGroup } from '@fortawesome/pro-light-svg-icons'
import { useCallback } from 'react'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { ITIconToolTip } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { InputTableLayoutData } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/types'

export interface OrderChangePackUnitProps {
    allRowData: RowData
    readOnlyFnc?: (allRowData: RowData) => boolean
    setCompleteData: React.Dispatch<React.SetStateAction<InputTableLayoutData | null>>
}

const OrderChangePackUnit: React.FC<OrderChangePackUnitProps> = ({ setCompleteData, allRowData, readOnlyFnc }) => {
    const { t } = useTwinTranslation()
    const packQuantity = allRowData?.packQuantity
    const readOnly = readOnlyFnc?.(allRowData)

    const myOpenModal = useCallback(() => {
        if (packQuantity) {
            setCompleteData((old) => {
                const copyOld = JSON.parse(JSON.stringify(old))
                copyOld.header.errorsToResolve.push({ element: allRowData, errorToResolve: '__left_select_quantity' })
                return copyOld
            })
        }
    }, [setCompleteData, allRowData, packQuantity])

    if (!packQuantity || readOnly) {
        return null
    }

    return (
        <ITIconToolTip message={packQuantity ? t('changeUnitsPack', 'Editar unidades del pack') : ''} id={'packUnits' + allRowData?.id || ''} icon={faLayerGroup} onClick={myOpenModal} />
    )
}

export default OrderChangePackUnit
